<template>
    <div class="clientDetail">
      <!--navBar-->
      <navBar></navBar>
      <!--中间内容部分-->
      <div class="main">
        <div class="mainContainer">
          <div class="nav_detail">
            <span class="nav_back" @click="goBack">案例中心</span> > <span>夏娃科技</span>
          </div>
          <div class="flex_between">
            <div class="item_left">
              <div class="icon"><i></i></div>
              <p class="title">夏娃科技</p>
              <div class="intro">
                <div>客户简介</div>
                <p>夏娃科技是一家以“保护生育力”为宗旨的公司，致力于为中国女性提供科学、全面的生育力保护整体解决方案。夏娃科技发起的“智慧生育管理”项目，是一个基于大数据、人工智能AI和云计算驱动的创新医疗解决方案，旨在通过技术创新和科普教育，解决我国意外怀孕和人流泛滥的社会痛点，提高不孕不育诊疗效率，促进女性生殖健康。</p>
              </div>
              <div class="products">
                <div>使用产品</div>
                <p @click="goProduct('/product2')">渗透测试</p>
                <p @click="goProduct('/product3')">专家服务</p>
              </div>
            </div>
            <div class="item_right">
              <div class="title">
                <i></i>业务背景
              </div>
              <p>夏娃科技以保护生育力为宗旨，通过技术创新和科普教育，解决我国意外怀孕和人流泛滥的社会痛点，提高不孕不育诊疗效率，促进女性生殖健康。其多项信息都是需要隐私和保密的，因此，系统的的网络安全与用户的个人隐私安全息息相关，因此需要对其网站及系统进行相关全面的网络安全扫描检测，保障用户隐私。</p>
              <div class="item_img"><img src="../../assets/img/clientDetail/client4_big.jpg" alt=""></div>
              <div class="title">
                <i></i>解决方案
              </div>
              <p>包括但不限于：Web应用、主机、弱密码；对企业与个人的多种资产进行专业的漏洞扫描。扫描引擎智能调度，保证用户业务不中断；智能无害扫描，避免扫描脏数据写入用户数据库。针对不同的客户体检模式，贴合您的不同场景需求，为您人性化输出漏洞情况。模拟黑客攻击对业务系统进行安全性测试，比黑客更早发现可导致企业数据泄露、资产受损、数据被篡改等漏洞，并协助企业进行修复。</p>
              <div class="title">
                <i></i>方案价值
              </div>
              <p>提升现有安全防护能力，帮助客户分担风险，保障业务高可用，避免公司因为监管需求和合规要求等带来的产品销售受限，无法开展相应业务等问题。保护公司品牌免收黑客入侵、数据泄露、产品安全和人身安全等带来的企业负面影响，协助公司树立安全可靠的品牌形象。</p>
            </div>
          </div>
        </div>
      </div>
      <!--footerBar-->
      <div class="gw_homefooterBox">
        <footerBar></footerBar>
      </div>
    </div>
</template>

<script>
    import navBar from '../../components/Navbar';
    import footerBar from '../../components/footerbar'
    export default {
      components:{
        navBar,footerBar
      },
      methods:{
        goBack(){
          this.$router.push('/client');
        },
        goProduct(url){
          this.$router.push(url);
          window.scrollTo({top:0});
        }
      }
    }
</script>

<style scoped lang="scss">
  .clientDetail{
    .item_left{
      .icon{
        i{
          width:160px;
          height:40px;
          background:url("../../assets/img/clientDetail/client4_icon.png") no-repeat center;
          background-size:100% 100%;
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/views/client/client4.vue